import Page from '../models/page';

function initDashboard() {
  if (Page.controller !== 'static_pages' || Page.action !== 'home') return;

  const maxLength = 1000;

  $('#content').on('input', function() {
    const $remaining = $('#site-feedback-content-remaining');
    const $submitButton = $('#site-feedback-submit');
    const contentLength = $(this).val().length;

    $remaining.text(1000 - contentLength);
    $submitButton.prop('disabled', contentLength === 0 || contentLength > maxLength);
  });

  $('.dashboard-score-overlay').each(function() {
    const options = { width: $(this).attr('data-score') + '%' };

    $(this).animate(options, maxLength);
  });
}

export default initDashboard;
